// src/timezones.js

// Countries with their flags and timezones
export const COUNTRIES = [
  // Americas
  { country: 'United States', flag: '🇺🇸', regions: [
    { region: 'Eastern (New York)', timezone: 'America/New_York', offset: -5 },
    { region: 'Central (Chicago)', timezone: 'America/Chicago', offset: -6 },
    { region: 'Mountain (Denver)', timezone: 'America/Denver', offset: -7 },
    { region: 'Pacific (Los Angeles)', timezone: 'America/Los_Angeles', offset: -8 },
    { region: 'Alaska', timezone: 'America/Anchorage', offset: -9 },
    { region: 'Hawaii', timezone: 'Pacific/Honolulu', offset: -10 },
  ]},
  { country: 'Canada', flag: '🇨🇦', regions: [
    { region: 'Eastern (Toronto)', timezone: 'America/Toronto', offset: -5 },
    { region: 'Central (Winnipeg)', timezone: 'America/Winnipeg', offset: -6 },
    { region: 'Mountain (Calgary)', timezone: 'America/Edmonton', offset: -7 },
    { region: 'Pacific (Vancouver)', timezone: 'America/Vancouver', offset: -8 },
  ]},
  { country: 'Mexico', flag: '🇲🇽', timezone: 'America/Mexico_City', offset: -6 },
  { country: 'Brazil', flag: '🇧🇷', regions: [
    { region: 'São Paulo', timezone: 'America/Sao_Paulo', offset: -3 },
    { region: 'Manaus', timezone: 'America/Manaus', offset: -4 },
  ]},
  { country: 'Argentina', flag: '🇦🇷', timezone: 'America/Argentina/Buenos_Aires', offset: -3 },
  { country: 'Colombia', flag: '🇨🇴', timezone: 'America/Bogota', offset: -5 },
  { country: 'Chile', flag: '🇨🇱', timezone: 'America/Santiago', offset: -3 },
  { country: 'Peru', flag: '🇵🇪', timezone: 'America/Lima', offset: -5 },
  
  // Europe
  { country: 'United Kingdom', flag: '🇬🇧', timezone: 'Europe/London', offset: 0 },
  { country: 'Ireland', flag: '🇮🇪', timezone: 'Europe/Dublin', offset: 0 },
  { country: 'France', flag: '🇫🇷', timezone: 'Europe/Paris', offset: 1 },
  { country: 'Germany', flag: '🇩🇪', timezone: 'Europe/Berlin', offset: 1 },
  { country: 'Italy', flag: '🇮🇹', timezone: 'Europe/Rome', offset: 1 },
  { country: 'Spain', flag: '🇪🇸', timezone: 'Europe/Madrid', offset: 1 },
  { country: 'Portugal', flag: '🇵🇹', timezone: 'Europe/Lisbon', offset: 0 },
  { country: 'Netherlands', flag: '🇳🇱', timezone: 'Europe/Amsterdam', offset: 1 },
  { country: 'Belgium', flag: '🇧🇪', timezone: 'Europe/Brussels', offset: 1 },
  { country: 'Switzerland', flag: '🇨🇭', timezone: 'Europe/Zurich', offset: 1 },
  { country: 'Austria', flag: '🇦🇹', timezone: 'Europe/Vienna', offset: 1 },
  { country: 'Sweden', flag: '🇸🇪', timezone: 'Europe/Stockholm', offset: 1 },
  { country: 'Norway', flag: '🇳🇴', timezone: 'Europe/Oslo', offset: 1 },
  { country: 'Denmark', flag: '🇩🇰', timezone: 'Europe/Copenhagen', offset: 1 },
  { country: 'Finland', flag: '🇫🇮', timezone: 'Europe/Helsinki', offset: 2 },
  { country: 'Poland', flag: '🇵🇱', timezone: 'Europe/Warsaw', offset: 1 },
  { country: 'Czech Republic', flag: '🇨🇿', timezone: 'Europe/Prague', offset: 1 },
  { country: 'Greece', flag: '🇬🇷', timezone: 'Europe/Athens', offset: 2 },
  { country: 'Turkey', flag: '🇹🇷', timezone: 'Europe/Istanbul', offset: 3 },
  { country: 'Russia', flag: '🇷🇺', regions: [
    { region: 'Moscow', timezone: 'Europe/Moscow', offset: 3 },
    { region: 'Yekaterinburg', timezone: 'Asia/Yekaterinburg', offset: 5 },
    { region: 'Vladivostok', timezone: 'Asia/Vladivostok', offset: 10 },
  ]},
  { country: 'Ukraine', flag: '🇺🇦', timezone: 'Europe/Kiev', offset: 2 },
  
  // Middle East
  { country: 'Israel', flag: '🇮🇱', timezone: 'Asia/Jerusalem', offset: 2 },
  { country: 'United Arab Emirates', flag: '🇦🇪', timezone: 'Asia/Dubai', offset: 4 },
  { country: 'Saudi Arabia', flag: '🇸🇦', timezone: 'Asia/Riyadh', offset: 3 },
  { country: 'Qatar', flag: '🇶🇦', timezone: 'Asia/Qatar', offset: 3 },
  { country: 'Kuwait', flag: '🇰🇼', timezone: 'Asia/Kuwait', offset: 3 },
  { country: 'Egypt', flag: '🇪🇬', timezone: 'Africa/Cairo', offset: 2 },
  
  // Africa
  { country: 'South Africa', flag: '🇿🇦', timezone: 'Africa/Johannesburg', offset: 2 },
  { country: 'Nigeria', flag: '🇳🇬', timezone: 'Africa/Lagos', offset: 1 },
  { country: 'Kenya', flag: '🇰🇪', timezone: 'Africa/Nairobi', offset: 3 },
  { country: 'Morocco', flag: '🇲🇦', timezone: 'Africa/Casablanca', offset: 1 },
  { country: 'Ghana', flag: '🇬🇭', timezone: 'Africa/Accra', offset: 0 },
  
  // Asia
  { country: 'India', flag: '🇮🇳', timezone: 'Asia/Kolkata', offset: 5.5 },
  { country: 'Pakistan', flag: '🇵🇰', timezone: 'Asia/Karachi', offset: 5 },
  { country: 'Bangladesh', flag: '🇧🇩', timezone: 'Asia/Dhaka', offset: 6 },
  { country: 'China', flag: '🇨🇳', timezone: 'Asia/Shanghai', offset: 8 },
  { country: 'Japan', flag: '🇯🇵', timezone: 'Asia/Tokyo', offset: 9 },
  { country: 'South Korea', flag: '🇰🇷', timezone: 'Asia/Seoul', offset: 9 },
  { country: 'Taiwan', flag: '🇹🇼', timezone: 'Asia/Taipei', offset: 8 },
  { country: 'Hong Kong', flag: '🇭🇰', timezone: 'Asia/Hong_Kong', offset: 8 },
  { country: 'Singapore', flag: '🇸🇬', timezone: 'Asia/Singapore', offset: 8 },
  { country: 'Malaysia', flag: '🇲🇾', timezone: 'Asia/Kuala_Lumpur', offset: 8 },
  { country: 'Thailand', flag: '🇹🇭', timezone: 'Asia/Bangkok', offset: 7 },
  { country: 'Vietnam', flag: '🇻🇳', timezone: 'Asia/Ho_Chi_Minh', offset: 7 },
  { country: 'Indonesia', flag: '🇮🇩', regions: [
    { region: 'Jakarta', timezone: 'Asia/Jakarta', offset: 7 },
    { region: 'Bali', timezone: 'Asia/Makassar', offset: 8 },
  ]},
  { country: 'Philippines', flag: '🇵🇭', timezone: 'Asia/Manila', offset: 8 },
  
  // Oceania
  { country: 'Australia', flag: '🇦🇺', regions: [
    { region: 'Sydney/Melbourne', timezone: 'Australia/Sydney', offset: 10 },
    { region: 'Brisbane', timezone: 'Australia/Brisbane', offset: 10 },
    { region: 'Perth', timezone: 'Australia/Perth', offset: 8 },
    { region: 'Adelaide', timezone: 'Australia/Adelaide', offset: 9.5 },
  ]},
  { country: 'New Zealand', flag: '🇳🇿', timezone: 'Pacific/Auckland', offset: 12 },
  { country: 'Fiji', flag: '🇫🇯', timezone: 'Pacific/Fiji', offset: 12 },
];

// Legacy TIMEZONES array for backward compatibility
export const TIMEZONES = [
  { value: 'Pacific/Honolulu', label: 'Hawaii (HST)', offset: -10 },
  { value: 'America/Anchorage', label: 'Alaska (AKST)', offset: -9 },
  { value: 'America/Los_Angeles', label: 'Pacific Time - Los Angeles (PST)', offset: -8 },
  { value: 'America/Denver', label: 'Mountain Time - Denver (MST)', offset: -7 },
  { value: 'America/Chicago', label: 'Central Time - Chicago (CST)', offset: -6 },
  { value: 'America/New_York', label: 'Eastern Time - New York (EST)', offset: -5 },
  { value: 'America/Toronto', label: 'Eastern Time - Toronto (EST)', offset: -5 },
  { value: 'America/Mexico_City', label: 'Mexico City (CST)', offset: -6 },
  { value: 'America/Sao_Paulo', label: 'Brazil - São Paulo (BRT)', offset: -3 },
  { value: 'America/Argentina/Buenos_Aires', label: 'Argentina (ART)', offset: -3 },
  { value: 'Atlantic/Reykjavik', label: 'Iceland (GMT)', offset: 0 },
  { value: 'Europe/London', label: 'United Kingdom (GMT/BST)', offset: 0 },
  { value: 'Europe/Dublin', label: 'Ireland (GMT/IST)', offset: 0 },
  { value: 'Europe/Lisbon', label: 'Portugal (WET)', offset: 0 },
  { value: 'Europe/Paris', label: 'France (CET)', offset: 1 },
  { value: 'Europe/Berlin', label: 'Germany (CET)', offset: 1 },
  { value: 'Europe/Rome', label: 'Italy (CET)', offset: 1 },
  { value: 'Europe/Madrid', label: 'Spain (CET)', offset: 1 },
  { value: 'Europe/Amsterdam', label: 'Netherlands (CET)', offset: 1 },
  { value: 'Europe/Brussels', label: 'Belgium (CET)', offset: 1 },
  { value: 'Europe/Zurich', label: 'Switzerland (CET)', offset: 1 },
  { value: 'Europe/Vienna', label: 'Austria (CET)', offset: 1 },
  { value: 'Europe/Stockholm', label: 'Sweden (CET)', offset: 1 },
  { value: 'Europe/Oslo', label: 'Norway (CET)', offset: 1 },
  { value: 'Europe/Copenhagen', label: 'Denmark (CET)', offset: 1 },
  { value: 'Europe/Warsaw', label: 'Poland (CET)', offset: 1 },
  { value: 'Europe/Prague', label: 'Czech Republic (CET)', offset: 1 },
  { value: 'Europe/Helsinki', label: 'Finland (EET)', offset: 2 },
  { value: 'Europe/Athens', label: 'Greece (EET)', offset: 2 },
  { value: 'Europe/Kiev', label: 'Ukraine (EET)', offset: 2 },
  { value: 'Europe/Istanbul', label: 'Turkey (TRT)', offset: 3 },
  { value: 'Europe/Moscow', label: 'Russia - Moscow (MSK)', offset: 3 },
  { value: 'Asia/Jerusalem', label: 'Israel (IST)', offset: 2 },
  { value: 'Africa/Cairo', label: 'Egypt (EET)', offset: 2 },
  { value: 'Africa/Johannesburg', label: 'South Africa (SAST)', offset: 2 },
  { value: 'Africa/Lagos', label: 'Nigeria (WAT)', offset: 1 },
  { value: 'Africa/Nairobi', label: 'Kenya (EAT)', offset: 3 },
  { value: 'Asia/Dubai', label: 'UAE - Dubai (GST)', offset: 4 },
  { value: 'Asia/Riyadh', label: 'Saudi Arabia (AST)', offset: 3 },
  { value: 'Asia/Karachi', label: 'Pakistan (PKT)', offset: 5 },
  { value: 'Asia/Kolkata', label: 'India (IST)', offset: 5.5 },
  { value: 'Asia/Dhaka', label: 'Bangladesh (BST)', offset: 6 },
  { value: 'Asia/Bangkok', label: 'Thailand (ICT)', offset: 7 },
  { value: 'Asia/Ho_Chi_Minh', label: 'Vietnam (ICT)', offset: 7 },
  { value: 'Asia/Jakarta', label: 'Indonesia - Jakarta (WIB)', offset: 7 },
  { value: 'Asia/Singapore', label: 'Singapore (SGT)', offset: 8 },
  { value: 'Asia/Kuala_Lumpur', label: 'Malaysia (MYT)', offset: 8 },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)', offset: 8 },
  { value: 'Asia/Shanghai', label: 'China (CST)', offset: 8 },
  { value: 'Asia/Taipei', label: 'Taiwan (CST)', offset: 8 },
  { value: 'Asia/Manila', label: 'Philippines (PHT)', offset: 8 },
  { value: 'Asia/Tokyo', label: 'Japan (JST)', offset: 9 },
  { value: 'Asia/Seoul', label: 'South Korea (KST)', offset: 9 },
  { value: 'Australia/Perth', label: 'Australia - Perth (AWST)', offset: 8 },
  { value: 'Australia/Adelaide', label: 'Australia - Adelaide (ACST)', offset: 9.5 },
  { value: 'Australia/Sydney', label: 'Australia - Sydney (AEST)', offset: 10 },
  { value: 'Australia/Brisbane', label: 'Australia - Brisbane (AEST)', offset: 10 },
  { value: 'Pacific/Auckland', label: 'New Zealand (NZST)', offset: 12 },
  { value: 'Pacific/Fiji', label: 'Fiji (FJT)', offset: 12 },
];

export const HOURS = [
  '00:00', '01:00', '02:00', '03:00', '04:00', '05:00',
  '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
  '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
  '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
];

export const formatHour = (hour) => {
  // Handle both number (9) and string ("09:00") formats
  let h;
  if (typeof hour === 'number') {
    h = hour;
  } else if (typeof hour === 'string' && hour.includes(':')) {
    h = parseInt(hour.split(':')[0]);
  } else {
    h = parseInt(hour) || 0;
  }
  
  if (h === 0) return '12 AM';
  if (h === 12) return '12 PM';
  if (h < 12) return `${h} AM`;
  return `${h - 12} PM`;
};

// Convert a date/time from one timezone to another
// Returns { date: 'YYYY-MM-DD', hour: 'HH:00', dayOffset: -1|0|1 }
export const convertTimezone = (dateStr, hour, fromTz, toTz) => {
  const fromZone = TIMEZONES.find(t => t.value === fromTz);
  const toZone = TIMEZONES.find(t => t.value === toTz);
  
  if (!fromZone || !toZone) return { date: dateStr, hour, dayOffset: 0 };
  
  let hourNum;
  if (typeof hour === 'number') {
    hourNum = hour;
  } else if (typeof hour === 'string' && hour.includes(':')) {
    hourNum = parseInt(hour.split(':')[0]);
  } else {
    hourNum = parseInt(hour) || 0;
  }
  
  // Calculate offset difference (handles fractional offsets like India +5.5)
  const offsetDiff = toZone.offset - fromZone.offset;
  
  // Convert to minutes for precision with fractional timezones
  const totalMinutes = hourNum * 60 + (offsetDiff * 60);
  
  let newHour = Math.floor(totalMinutes / 60);
  let dayOffset = 0;
  
  // Handle day boundary crossing
  if (newHour >= 24) {
    newHour -= 24;
    dayOffset = 1;
  } else if (newHour < 0) {
    newHour += 24;
    dayOffset = -1;
  }
  
  // Adjust date based on day offset
  const date = new Date(dateStr + 'T12:00:00'); // Use noon to avoid DST issues
  date.setDate(date.getDate() + dayOffset);
  const newDateStr = date.toISOString().split('T')[0];
  
  return {
    date: newDateStr,
    hour: `${String(Math.floor(newHour)).padStart(2, '0')}:00`,
    dayOffset: dayOffset
  };
};

// Get country info from timezone
export const getCountryFromTimezone = (tzValue) => {
  for (const country of COUNTRIES) {
    if (country.timezone === tzValue) {
      return { country: country.country, flag: country.flag };
    }
    if (country.regions) {
      for (const region of country.regions) {
        if (region.timezone === tzValue) {
          return { country: country.country, flag: country.flag, region: region.region };
        }
      }
    }
  }
  return null;
};
